import React, {useEffect, useState} from 'react';
import {BsFillMicFill, BsMic} from "react-icons/bs";
import {runtimeVoiceExecute} from "../../services/runtime";
import * as realTimeApi from "../../real-time-api-config";
import {connect} from "react-redux";
import {voiceModeChange} from "../../redux/app/app-actions";

function getBase64(file) {
    return new Promise(resolve => {
        let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            resolve(baseURL);
        };
    });
};

function VoiceRecorder({appId, sessionId, accessKey, onChangeVoiceInvokeState, chatBotSetting, voiceModeChangeHandle}) {
    const [recording, setRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState();

    const audioChunks = []

    const [formState, setFormState] = useState({
        processing: false,
        success: false,
        failed: false,
        message: '',
    });

    const updateFormState = ({ processing, success, failed, message }) => {
        setFormState(
            { processing, success, failed, message }
        );
    };

    useEffect(() => {
        return () => {
            if (mediaRecorder) {
                mediaRecorder.stop();
            }
        }
    }, [])

    useEffect(() => {
        onChangeVoiceInvokeState(formState)
    }, [formState])

    const handleAudioRecord = () => {
        voiceModeChangeHandle(true);
    }

    const __handleAudioRecord = () => {
        if (recording) {
            mediaRecorder.stop();
        } else {
            navigator.mediaDevices.getUserMedia({ audio: true })
                .then(stream => {
                    const _mediaRecorder = new MediaRecorder(stream);
                    _mediaRecorder.ondataavailable = function (event) {
                        console.log("on dataavailable", event)
                        if (event.data.size > 0) {
                            audioChunks.push(event.data)
                        }
                    };

                    _mediaRecorder.onstop = async function (event) {
                        try {
                            updateFormState({ processing: true })
                            const audioBlob = new Blob(audioChunks, { type: 'audio/mpeg-3' });
                            const audioBase64 = (await getBase64(audioBlob)).replace("data:audio/mpeg-3;base64,", "")
                            // const response = await runtimeVoiceExecute(appId, {
                            //     audioBase64,
                            //     sessionId
                            // }, accessKey);
                            await realTimeApi.sendUserMessage(accessKey, appId, sessionId, JSON.stringify({
                                action:"executor",
                                appId,
                                sessionId,
                                inputText: '',
                                voiceMessage: audioBase64
                            }))
                            // updateFormState({
                            //     processing: false,
                            //     success: 'success'
                            // })
                        } catch (e) {
                            updateFormState({
                                processing: false,
                                failed: true,
                                message: 'Unable to send message'
                            })
                            console.error("onstop error", e)
                        }
                    }

                    _mediaRecorder.onerror = function (error) {
                        updateFormState({
                            processing: false,
                            failed: true,
                            message: 'Unable to record audio'
                        })
                        console.error("onerror", error)
                    }

                    _mediaRecorder.start();

                    setMediaRecorder(_mediaRecorder);
                });

        }
        setRecording(!recording);
    };

    return (
    <div style={{color: chatBotSetting.headerBackgroundColor}} className="relative inline-flex p-2 text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50 hover:rounded-full">
        {/*<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 cursor-pointer" onClick={handleAudioRecord}>*/}
        {/*    <path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5" />*/}
        {/*</svg>*/}
        {recording?
            <div>
                <BsFillMicFill  className="w-5 h-5 cursor-pointer" onClick={handleAudioRecord}/>
                <div className="flex absolute top-0 right-0 -mt-0.5 -mr-1">
                          <span className="absolute inline-flex animate-ping">
                            <span className="inline-flex rounded-full h-3 w-3 bg-red-400 opacity-75"></span>
                          </span>
                    <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                </div>
            </div>:
            <BsMic  className="w-5 h-5 cursor-pointer" onClick={handleAudioRecord}/>
        }


    </div>
    );
};

const mapsStateToProps = (state, ownProps) => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        voiceModeChangeHandle: (status) => {
            dispatch(voiceModeChange(status));
        },
    };
}

export default connect(mapsStateToProps, mapDispatchToProps)(VoiceRecorder)